import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV, SERVICES, CONTACT } from "../data/site";
import { Socials } from "./Socials";
import { ArrowButton } from "./Buttons";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-bottle-green text-cream">
    {/* CTA band */}
    <div className="border-b border-cream/12">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20 md:py-28 grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-8">
          <span className="label text-cream/50">Let's work together</span>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] mt-5">
            Have an idea?<br />Let's make it matter.
          </h2>
        </div>
        <div className="md:col-span-4 md:text-right">
          <ArrowButton to="/contact" variant="light" testid="footer-start-project">Start a Project</ArrowButton>
        </div>
      </div>
    </div>

    {/* Link columns */}
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-16 grid grid-cols-2 md:grid-cols-12 gap-10">
      <div className="col-span-2 md:col-span-4">
        <img src="/logos/tara-monogram.jpg" alt="Tara Creative Group" className="h-16 w-auto rounded-sm" draggable="false" />
        <div className="font-serif text-3xl mt-5">Tara</div>
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-cream/60 mt-1">Creative Group</div>
        <p className="font-sans text-sm text-cream/65 leading-relaxed mt-6 max-w-xs">
          A creative marketing and branding agency combining strategy, creativity and communication to build brands that connect, engage and grow.
        </p>
      </div>

      <div className="md:col-span-2 md:col-start-6">
        <span className="label text-cream/45">Navigate</span>
        <ul className="mt-5 space-y-2.5">
          {NAV.map((n) => (
            <li key={n.path}>
              <Link
                to={n.path}
                data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-sans text-sm text-cream/75 hover:text-cream transition-colors link-underline"
              >
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <span className="label text-cream/45">Services</span>
        <ul className="mt-5 space-y-2.5">
          {SERVICES.slice(0, 6).map((s) => (
            <li key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`footer-service-${s.slug}`}
                className="font-sans text-sm text-cream/75 hover:text-cream transition-colors link-underline"
              >
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="col-span-2 md:col-span-3">
        <span className="label text-cream/45">Get in touch</span>
        <ul className="mt-5 space-y-3 font-sans text-sm text-cream/75">
          <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-cream transition-colors">{CONTACT.email}</a></li>
          <li><a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone-link" className="hover:text-cream transition-colors">{CONTACT.phone}</a></li>
          <li className="leading-relaxed text-cream/60">{CONTACT.location}</li>
        </ul>
        <div className="flex gap-3 mt-6">
          <Socials variant="boxLight" />
        </div>
      </div>
    </div>

    <div className="border-t border-cream/12">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 font-mono text-[11px] tracking-widest uppercase text-cream/45">
        <span>© {new Date().getFullYear()} Tara Creative Group</span>
        <span className="flex items-center gap-1">Think. Create. Connect. <ArrowUpRight className="w-3 h-3" /></span>
      </div>
    </div>
  </footer>
);
